import { render, staticRenderFns } from "./UserPasswordChangeInputs.vue?vue&type=template&id=7120b674&"
import script from "./UserPasswordChangeInputs.vue?vue&type=script&lang=ts&"
export * from "./UserPasswordChangeInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports